"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { getPwaConfig } from "./pwaConfig";
import { syncPwaAppFromLocation } from "./pwaApp";

function upsertLink(rel, href, extra = {}) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
  Object.entries(extra).forEach(([key, value]) => {
    if (value) link.setAttribute(key, value);
  });
}

function upsertMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

export function PwaManifestSwitcher() {
  const pathname = usePathname();

  useEffect(() => {
    const appId = pathname?.startsWith("/super-admin")
      ? "admin"
      : syncPwaAppFromLocation();
    const config = getPwaConfig(appId);

    upsertLink("manifest", config.manifestHref);
    upsertLink("apple-touch-icon", config.appleTouchIcon, {
      sizes: "180x180",
      type: "image/png",
    });
    upsertLink("icon", config.appleTouchIcon, {
      sizes: "192x192",
      type: "image/png",
    });
    upsertMeta("apple-mobile-web-app-title", config.appleWebAppTitle);
    upsertMeta("theme-color", config.themeColor);
  }, [pathname]);

  return null;
}
